<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title>
        {{ page.pageName }}
      </v-card-title>
      <v-card-subtitle>
        <v-row dense>
          <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ page.id }} </v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text class="py-0">
        <v-tabs
          v-model="tab"
          fixed-tabs
        >
          <v-tab> Details </v-tab>
          <v-tab>Long</v-tab>
          <v-tab>FAQ</v-tab>
        </v-tabs>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-tabs-items
            v-model="tab"
            class="pt-2"
          >
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="page.heading"
                    label="Heading"
                    outlined
                    hide-details="auto"
                    :disabled="!is_admin"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="page.title"
                    label="Title"
                    outlined
                    hide-details="auto"
                    :rules="[$rules.required]"
                    :disabled="!is_admin"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="page.meta"
                    label="Meta"
                    outlined
                    hide-details="auto"
                    :disabled="!is_admin"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="page.description"
                    label="Description"
                    outlined
                    auto-grow
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="page.longContent"
                    label="Long Content"
                    outlined
                    auto-grow
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <SimpleQuestion
                v-for="(item, i) in sortedQuestions"
                :key="i"
                :question="item"
                @save="loadData(page.id)"
              />
              <v-row>
                <v-col cols="12">
                  <v-btn
                    block
                    outlined
                    @click="editQuestion(null)"
                  >
                    Add Question
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <EditQuestion @save="loadData(page.id)" />
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import EditQuestion from '@/components/content/catalog/EditQuestion';
import SimpleQuestion from '@/components/content/catalog/SimpleQuestion';
import { sortBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogEditPage',

  components: { SimpleQuestion, EditQuestion },

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      tab: 0
    };
  },

  computed: {
    page: {
      get() {
        return this.$store.getters['catalogPages/edit_catalog_page'];
      },
      set(val) {
        this.$store.dispatch('catalogPages/edit', val);
      }
    },
    sortedQuestions() {
      return sortBy(this.page.questions, 'ranking');
    },
    ...mapGetters({ is_admin: 'auth/is_admin' })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_SHOW, (data) => {
      this.loadData(data.id);
      this.drawer = true;
    });
  },

  methods: {
    loadData(id) {
      this.loading = true;
      this.$store
        .dispatch('catalogPages/getCatalogPage', id)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('catalogPages/updateCatalogPage', this.page)
        .then(() => {
          this.drawer = false;
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    editQuestion(question) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_QUESTION_SHOW, {
        question: question || { catalogContentPageId: this.page.id }
      });
    }
  }
};
</script>
